import React from "react";
import Preloader from "./components/preloader";
import Routes from "./routes";

const App = () => {
  return (
    <div className="App">
      {/* Pre Loader */}
      <Preloader />
      {/* Main Container */}
      <div id="home">
        <div id="about">
          <div id="resume">
            <div id="portfolio">
              <div id="blog">
                <div id="contact">
                  <Routes />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
